import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { prefersReducedMotion } from "@/utils/media";

gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

const defaults = {
  ease: "power2.out",
  duration: 1.2,
};

gsap.defaults(defaults);

const reduced = prefersReducedMotion();

export default gsap;
export { defaults, reduced, ScrollTrigger, SplitText, DrawSVGPlugin };
